// Libs
import React, { useCallback } from 'react'

// Components
import ListPageHeader from 'k8s/components/common/ListPageHeader'

// Helpers
import { getUsageTotals } from 'k8s/util/calcUsageTotals'

// Types
import { nodeStatusCardProps } from 'k8s/components/dashboard/card-templates'
import { INodesSelector } from './model'
import DocumentMeta from 'core/components/DocumentMeta'

const maxUsagePaths = {
  computeMaxPath: 'combined.usage.compute.max',
  memoryMaxPath: 'combined.usage.memory.max',
  diskMaxPath: 'combined.usage.disk.max',
}

const curUsagePaths = {
  computeCurrPath: 'combined.usage.compute.current',
  memoryCurrPath: 'combined.usage.memory.current',
  diskCurrPath: 'combined.usage.disk.current',
}

export const NodeListHeader = () => {
  const handleGetUsage = useCallback((nodes: INodesSelector[]) => {
    return getUsageTotals(nodes, curUsagePaths, maxUsagePaths)
  }, [])
  return (
    <ListPageHeader<INodesSelector>
      report={nodeStatusCardProps}
      totalUsageFn={handleGetUsage}
      documentMeta={<DocumentMeta title="Nodes" />}
      percentagePrecision={1}
    />
  )
}
